import React from "react";
import _ from "lodash";
import styles from "../leads.module.scss";
import { TableCellText } from "../../../common/TableCellText";

interface LeadDetailsProps {
  leadProfile: any;
}

const FIELDS: { label: string; key: string }[] = [
  { label: "First Name", key: "firstName" },
  { label: "Email", key: "email" },
  { label: "Last Name", key: "lastName" },
  { label: "Company", key: "company" },
  { label: "Designation", key: "title" },
  { label: "Work Phone", key: "workPhone" },
];

export const LeadDetails: React.FC<LeadDetailsProps> = ({ leadProfile }) => (
  <section className={styles.sectionContainer}>
    <hr className={styles.divider} />
    <header className={styles.sectionHeader}>
      <h4 className={styles.sectionHeading}>Basic Fields</h4>
    </header>
    <div className={styles.detailContainer}>
      {FIELDS.map((f) => (
        <div className={styles.detail} key={f.key}>
          <h6 className={styles.detailHeading}>{f.label}</h6>
          <TableCellText
            wrap
            className={styles.detailValue}
            text={_.get(leadProfile, f.key) || "-"}
          />
        </div>
      ))}
    </div>
  </section>
);

interface CustomFieldsProps {
  data: any[];
}

export const CustomFieldsDetails: React.FC<CustomFieldsProps> = ({ data }) => {
  const customFields = (data || []).filter((field) => field.uid === null);
  if (customFields.length === 0) return null;
  const renderValue = (value: unknown) => {
    if (typeof value === "boolean") return value ? "True" : "False";
    return (value as string) || "-";
  };

  return (
    <section className={styles.sectionContainer}>
      <hr className={styles.divider} />
      <header className={styles.sectionHeader}>
        <h4 className={styles.sectionHeading}>Custom Fields</h4>
      </header>
      <div className={styles.customFieldsContainer}>
        {customFields
          .map((field, index) => {
            const isArray = Array.isArray(field.values);
            const value = isArray ? field.values.join(", ") : renderValue(field.values);
            return (
              <div className={styles.customFieldPill} key={index}>
                <TableCellText
                  className={styles.customFieldLabel}
                  text={`${field.name}:`}
                />
                <TableCellText
                  className={styles.customFieldValue}
                  text={value || "-"}
                />
              </div>
            );
          })}
      </div>
    </section>
  );
};
